/**
 * ISSUE-1360. The link card under a text message, after v1's
 * `message_link_preview.dart`: the site, the page title and a two-line
 * description, the whole card one link that opens in a new tab.
 *
 * messaging-api fills `linkPreview` server side through an SSRF-safe unfurl
 * (https only), so the browser never fetches the page itself. There is no
 * image on purpose: hotlinking it would hand the fan's IP to the site, and
 * re-hosting needs an owner answer first (messaging overview, "Link cards").
 */
import { FOCUS_RING } from "@sportsmet/ui";
import type { ReactNode } from "react";

import type { typeMessageLinkPreview } from "./mergeMessagePages";

export function linkPreviewSiteLabel(preview: typeMessageLinkPreview): string {
  const siteName = preview.siteName?.trim() ?? "";
  return siteName !== "" ? siteName : preview.hostname;
}

export function LinkPreviewCard({
  preview,
  isOwn,
}: {
  preview: typeMessageLinkPreview;
  isOwn: boolean;
}): ReactNode {
  return (
    <a
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="message-link-preview"
      className={`flex flex-col gap-1 rounded-md border-l-4 border-primary px-3 py-2 ${
        isOwn ? "bg-surface" : "bg-surface-secondary"
      } hover:underline ${FOCUS_RING}`}
    >
      <span className="truncate text-caption text-ink-secondary">
        {linkPreviewSiteLabel(preview)}
      </span>
      <span className="line-clamp-2 text-body-strong text-ink">
        {preview.title}
      </span>
      {preview.description !== null && preview.description.trim() !== "" ? (
        <span className="line-clamp-2 text-caption text-ink-secondary">
          {preview.description}
        </span>
      ) : null}
    </a>
  );
}
